import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Logo } from '../../components/Logo';

export function CreateWalletScreen({ onCreate }: { onCreate: () => Promise<void> }) {
  const { t } = useTranslation();
  const [busy, setBusy] = useState(false);
  return (
    <main className="flex min-h-screen items-center justify-center px-6 py-10">
      <div className="w-full max-w-sm text-center">
        <div className="mb-6 flex justify-center">
          <Logo variant="mark" size={48} />
        </div>
        <h1 className="text-lg font-semibold tracking-tightish text-ink-primary">
          {t('iframe.create.title')}
        </h1>
        <p className="mt-2 text-sm leading-relaxed text-ink-secondary">{t('iframe.create.body')}</p>
        <button
          onClick={async () => {
            setBusy(true);
            try {
              await onCreate();
            } finally {
              setBusy(false);
            }
          }}
          disabled={busy}
          className="mt-6 inline-flex h-11 w-full items-center justify-center rounded-lg bg-bit2me px-4 text-sm font-medium text-white transition-colors hover:bg-bit2me-mid disabled:bg-ink-muted"
        >
          {busy ? t('iframe.common.working') : t('iframe.create.cta')}
        </button>
        <p className="mt-4 font-mono text-[11px] uppercase tracking-eyebrow text-ink-tertiary">
          {t('iframe.create.disclaimer')}
        </p>
      </div>
    </main>
  );
}
